import React, { useState } from 'react';

/**
 * @param {Object} props
 * @param {Array<{ id: string, label: string, content: React.ReactNode }>} props.tabs
 */
export default function SideTabs({ tabs }) {
  const [activeTab, setActiveTab] = useState(tabs[0]?.id || '');

  return (
    <div className="tw-flex tw-h-full tw-grid tw-grid-cols-12">
      {/* Sidebar */}
      <div className="tw-col-span-12 lg:tw-col-span-3 2xl:tw-col-span-2 tw-p-4 tw-space-y-1">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`tw-w-full tw-text-left tw-px-4 tw-py-2 tw-text-sm tw-rounded-md
              ${
                activeTab === tab.id
                  ? 'tw-bg-blue-100 tw-font-semibold tw-text-blue-700'
                  : 'tw-hover:bg-gray-200 tw-text-gray-700'
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="tw-col-span-12 lg:tw-col-span-9 2xl:tw-col-span-10 tw-flex-1 tw-p-6 tw-h-full">
        {tabs.map(
          (tab) =>
            tab.id === activeTab && (
              <div key={tab.id} className="tw-h-full">
                {tab.content}
              </div>
            ),
        )}
      </div>
    </div>
  );
}
